import React from 'react';
import PropTypes from 'prop-types';
import s from './BusinessDetailsHome.module.css';
import { Text, ContentSnippet, VSpacer } from '@mqd/volt-base';
import { observer } from 'mobx-react';

function BusinessDetailsHome({ ownerType, editActive, home = {}, renderSnippet = () => {} }) {
  const addressDisplay = home?.displayUS || '';
  const isProprietor = ownerType === 'business proprietor or officer';
  const { address1, address2, city, state, postal_code, country, updateForSave } = home;

  if (editActive) {
    return (
      <>
        <Text type="h5">Home</Text>
        <VSpacer factor={2} />
        {renderSnippet({
          title: 'Address 1',
          content: address1,
          editActive: true,
          onChange: (e) => updateForSave('address1', e.target.value),
          tooltipContent: `Street address of ${ownerType}.`,
        })}
        {renderSnippet({
          title: 'Address 2',
          content: address2,
          editActive: true,
          onChange: (e) => updateForSave('address2', e.target.value),
          tooltipContent: 'Additional address information.',
        })}
        {renderSnippet({
          title: 'City',
          content: city,
          editActive: true,
          onChange: (e) => updateForSave('city', e.target.value),
          tooltipContent: `City in which ${ownerType} resides.`,
        })}
        {renderSnippet({
          title: 'State',
          content: state,
          editActive: true,
          onChange: (e) => updateForSave('state', e.target.value),
          tooltipContent: `State in which ${ownerType} resides.`,
        })}
        {renderSnippet({
          title: 'Postal Code',
          content: postal_code,
          editActive: true,
          onChange: (e) => updateForSave('postal_code', e.target.value),
          tooltipContent: `Postal code of ${ownerType}.`,
        })}
        {renderSnippet({
          title: 'Country',
          content: country,
          editActive: true,
          onChange: (e) => updateForSave('country', e.target.value),
          tooltipContent: `Country in which ${ownerType} resides.`,
        })}
      </>
    );
  }

  return (
    <ContentSnippet
      title="Home"
      testId="volt-content-snippet_title-Home"
      horizontalLayout
      tooltipProps={{ zIndex: 9999 }}
      tooltipContent={`
        Home address of ${ownerType}.
        ${isProprietor ? 'Required for verification (KYC) checks.' : ''}
      `}
      titleInline={!editActive ? { width: 180 } : null}
      contentInline={!editActive ? { flexGrow: 1 } : null}
    >
      <div className={s.address} data-testid={s.address}>
        {addressDisplay}
      </div>
    </ContentSnippet>
  );
}

BusinessDetailsHome.propTypes = {
  ownerType: PropTypes.string,
  editActive: PropTypes.bool,
  home: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
    displayUS: PropTypes.string,
    updateForSave: PropTypes.func,
  }),
  renderSnippet: PropTypes.func,
};

BusinessDetailsHome.defaultProps = {
  editActive: false,
  home: {},
};

export default observer(BusinessDetailsHome);
